/**
 * [PGF Draft Board Refresh v1.1 verdict 5.B] Single source of truth for
 * per-persona colors used across ChatPanel and DraftBoardChatTicker.
 *
 * Extracted from ChatPanel.jsx PERSONA_STYLES so both surfaces share the
 * exact same palette. Any future ChatPanel palette adjustment lands here
 * and the ticker picks it up automatically.
 *
 * Ticker uses `nameColor` (hex) for the team-name prefix. Bubble/label
 * fields remain ChatPanel-specific and stay attached to `PERSONA_STYLES`
 * where they're consumed as full Tailwind classnames.
 */

// Text/name hex colors per persona - used by the ticker for the team
// name prefix rendering and by ChatPanel for the bubble name text.
export const PERSONA_NAME_COLORS = Object.freeze({
  SmartMoney: "#7CC8E8",
  TheGrinder: "#C9CDD3",
  ValueHunter: "#F2BF7A",
});

// [ChatPanel bubble styling - full class strings for backward compat.]
export const PERSONA_STYLES = Object.freeze({
  SmartMoney: {
    bubble: "bg-[#1B2A38] border border-[#5BB7E5]/55",
    name: "text-[#7CC8E8]",
    label: "Smart Money",
  },
  TheGrinder: {
    bubble: "bg-[#222428] border border-[#9BA1A8]/55",
    name: "text-[#C9CDD3]",
    label: "The Grinder",
  },
  ValueHunter: {
    bubble: "bg-[#2A1F12] border border-[#E8A24B]/60",
    name: "text-[#F2BF7A]",
    label: "Value Hunter",
  },
});

/**
 * Resolve a display color for the ticker team-name prefix.
 *
 *   - Persona managers (SmartMoney/TheGrinder/ValueHunter) → their brand hex.
 *   - Human managers or unknown personas → theme-appropriate neutral.
 *
 * @param {object} manager  DraftState manager object (may have persona field).
 * @param {boolean} isDark  Current theme.
 * @returns {string} hex color for the ticker team-name prefix.
 */
export function personaNameColorFor(manager, isDark = true) {
  const persona = manager?.persona || manager?.persona_id;
  if (persona && PERSONA_NAME_COLORS[persona]) {
    return PERSONA_NAME_COLORS[persona];
  }
  return isDark ? "#F5F5F5" : "#0A0A0A";
}
